import CirclePerson from '../../src/legacy/CirclePerson.tsx';
export default CirclePerson;
